// Search only the readable text of FAQ answers, including nested lists.
export function getAnswerText(node) {
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(getAnswerText).join(" ");
  return node?.props ? getAnswerText(node.props.children) : "";
}

export function filterFaqs(faqs = [], query = "", locale = "en") {
  const normalize = (text) => text.toLocaleLowerCase(locale).normalize("NFKC");
  const terms = normalize(query.trim()).split(/\s+/).filter(Boolean);
  return faqs.filter((faq) => {
    const text = normalize(`${faq.question} ${getAnswerText(faq.answer)}`);
    return terms.every((term) => text.includes(term));
  });
}
